// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_ea870a', '__Inter_Fallback_ea870a'","fontStyle":"normal"},"className":"__className_ea870a","variable":"__variable_ea870a"};